import { motion } from "framer-motion";
import { TreePine, PenTool, Ruler, ShieldCheck, Handshake, HeartHandshake } from "lucide-react";
import { REVEAL } from "@/lib/site";

const CARDS = [
  { icon: TreePine, title: "Quality Wooden Furniture", desc: "Seasoned teak, sheesham and premium hardwoods — chosen board by board, never compromised." },
  { icon: PenTool, title: "Modern Designs", desc: "Clean, contemporary silhouettes designed for the way modern Indian homes actually live." },
  { icon: Ruler, title: "Customization", desc: "Sizes, finishes, storage layouts and fabrics tailored to your space and your measurements." },
  { icon: ShieldCheck, title: "Durable Construction", desc: "Proper joinery and treated timber engineered for decades of daily use, not just delivery day." },
  { icon: Handshake, title: "Professional Service", desc: "Clear quotes, honest timelines and careful delivery and installation at your doorstep." },
  { icon: HeartHandshake, title: "Customer Satisfaction", desc: "A local team that answers on WhatsApp and stands behind every piece we make." },
];

export const WhyUs = () => (
  <section id="why-us" className="bg-walnut py-20 sm:py-28">
    <div className="section-shell">
      <div className="max-w-2xl">
        <motion.p variants={REVEAL} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} className="eyebrow !text-brass">
          05 / Why Choose Us
        </motion.p>
        <motion.h2
          variants={REVEAL} custom={1} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
          className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-sand"
        >
          The JK Furniture <span className="italic text-brass">Distinction</span>
        </motion.h2>
      </div>

      <div data-testid="why-choose-us-grid" className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {CARDS.map((card, i) => (
          <motion.div
            key={card.title}
            data-testid={`why-card-${i + 1}`}
            variants={REVEAL} custom={i % 3} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
            className="group rounded-2xl border border-[#4A382C] bg-[#3A2A1F]/60 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-brass/60 hover:bg-[#3A2A1F]"
          >
            <div className="flex items-center justify-between">
              <card.icon size={26} className="text-brass" strokeWidth={1.5} />
              <span className="font-mono text-xs tracking-[0.2em] text-brasslight/50">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <h3 className="mt-6 font-serif text-xl text-sand">{card.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-brasslight/70">{card.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
